import React from "react";
import CustomSelect from "../../../CommonComponents/Select/CustomSelect";
import { FormControl, Grid } from "@mui/material";
import Button from "@mui/material/Button";
import { useEffect } from "react";
import {
  getStateMaster,
  getCitiesByState,
  getIMsByStateyAndCity,
  reassignToIM,
} from "../../../Services/caseManagement.service";
import { useState } from "react";
import { useSelector } from "react-redux";
import useToaster from "../../../customHook/useToaster";

const dropdownDetails = [
  {
    name: "state",
    label: "Select State",
    placeholder: "Select",
  },
  {
    name: "city",
    label: "Select City",
    placeholder: "Select",
  },
  {
    name: "user",
    label: "Select IM",
    placeholder: "Select",
  },
];

function ReassignCase({ onSuccess }) {
  const [IMDetails, setIMDetails] = useState([]);
  const [selectedDetails, setSelectedDetails] = useState({});
  const [options, setOptions] = useState({});
  const caseId = useSelector((state) => state?.CaseDescriptionSlice?.caseId);
  const { showToast } = useToaster();
  const isSubmitActive =
    selectedDetails?.state && selectedDetails?.city && selectedDetails?.user
      ? true
      : false;

  const fetchCities = (state) => {
    getCitiesByState(state)
      ?.then((response) => {
        if (response?.success) {
          setOptions((prev) => ({
            ...prev,
            city: response?.data,
            user: [],
          }));
        } else {
          setOptions((prev) => ({
            ...prev,
            city: [],
            user: [],
          }));
        }
      })
      ?.catch((err) => {
        setOptions((prev) => ({
          ...prev,
          city: [],
          user: [],
        }));
        showToast(err?.response?.data?.message, "error", true);
      });
  };

  const fetchUsers = (location) => {
    getIMsByStateyAndCity({ ...location, caseId })
      ?.then((response) => {
        if (response?.success) {
          setIMDetails(response?.data);
          setOptions((prev) => ({
            ...prev,
            user: response?.data?.map((data) => data?.employee_name),
          }));
        } else {
          setOptions((prev) => ({
            ...prev,
            user: ["No IM Availabe."],
          }));
        }
      })
      ?.catch((err) => {
        let message = err?.response?.data?.message;
        if (message?.toLowerCase() === "no data found")
          message = "No IM available at this location.";
        setOptions((prev) => ({
          ...prev,
          user: ["No IM Availabe."],
        }));
        showToast(message, "error", true);
      });
  };

  const handleChange = (e) => {
    let targetEle = e?.target?.name;
    let targetVal = e?.target?.value;
    let state = selectedDetails?.state;
    let city = selectedDetails?.city;
    let user = selectedDetails?.user;
    if (targetEle === "state") {
      state = targetVal;
      city = "";
      user = "";
      fetchCities(state);
    } else if (targetEle === "city") {
      city = targetVal;
      user = "";
      fetchUsers({ state, city });
    } else {
      user = targetVal;
    }
    setSelectedDetails((prev) => {
      return {
        ...prev,
        state,
        city,
        user,
      };
    });
  };

  const submitHandler = (e) => {
    if (
      !selectedDetails?.state ||
      !selectedDetails?.city ||
      !selectedDetails?.user
    )
      return showToast("Please select details.", "warning", true);

    let payload = {
      ...selectedDetails,
      caseId,
      assignToEmail: IMDetails?.find(
        (data) => data?.employee_name == selectedDetails?.user
      )?.email,
    };
    reassignToIM(payload)
      ?.then((response) => {
        if (response?.success) {
          onSuccess();
          showToast(response?.message, "success", true);
        }
      })
      ?.catch((err) => {
        showToast(err?.response?.data?.message, "error", true);
      });
  };

  useEffect(() => {
    getStateMaster()
      ?.then((response) => {
        if (response?.success) {
          setOptions((prev) => ({
            ...prev,
            state: response?.data,
          }));
        }
      })
      ?.catch((err) => {
        showToast(err?.response?.data?.message, "error", true);
      });
  }, []);

  return (
    <Grid
      sx={{
        padding: "0px",
        margin: "0px",
        width: "100%",
        height: "100%",
      }}
    >
      <Grid item xs={12}>
        <FormControl sx={{ width: "100%" }}>
          <Grid container spacing={0}>
            {dropdownDetails?.map((item, index) => (
              <Grid
                item
                xs={12}
                sx={{
                  paddingTop: index === 0 ? "unset" : "1rem",
                  display:
                    item?.name === "user"
                      ? selectedDetails?.state && selectedDetails?.city
                        ? "block"
                        : "none"
                      : "block",
                }}
              >
                <CustomSelect
                  label={item?.label}
                  placeholder={item?.placeholder}
                  customSelectValue={
                    selectedDetails?.[item?.name]
                      ? selectedDetails?.[item?.name]
                      : ""
                  }
                  name={item?.name}
                  options={
                    options?.[item?.name]?.length ? options?.[item?.name] : []
                  }
                  handleChange={handleChange}
                  height="4.4rem"
                  border="1px solid rgba(0,0,0,0.12)"
                  labelStyles={{
                    fontSize: "1.3rem",
                    fontWeight: 500,
                    color: "#070A13",
                    marginBottom: "5px",
                    fontStyle: "Inter",
                  }}
                  menuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: "calc(100% - 68%)",
                      },
                    },
                  }}
                />
              </Grid>
            ))}
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                paddingTop: "1.6rem",
              }}
            >
              <div>
                <Button
                  variant="contained"
                  sx={{
                    ":hover": {
                      bgcolor: "#e85055",
                      color: "white",
                    },
                    width: "max-content",
                    textTransform: "none",
                    display: "flex",
                    boxShadow: "none",
                    backgroundColor: isSubmitActive ? "#e85055" : "#F7BCBE",
                    fontSize: "1.4rem",
                    padding: "0.8rem 2.7rem",
                    color: isSubmitActive ? "white" : "#E42125",
                  }}
                  onClick={submitHandler}
                >
                  Re-assign
                </Button>
              </div>
            </Grid>
          </Grid>
        </FormControl>
      </Grid>
    </Grid>
  );
}

export default ReassignCase;
